const AddPurchaser = (data, setData) => {
  if (data.purchasersNum >= 1 && data.purchasersNum < 5) {
    let count;
    count = data.purchasersNum + 1;
    setData({ ...data, purchasersNum: count });
  }
};

export default AddPurchaser;
